import { api } from '../core/network/api';

/**
 * REST wrapper for the caller's world chat history.
 *
 * Confirmed against backend/src/game/chat/chat.controller.ts +
 * chat.gateway.ts: `GET /me/chat/history` flattens each row to
 * `senderUsername` (dropping the nested `sender` object it gets back from
 * ChatService.getHistory) specifically so history and the live
 * `chat:message` broadcast — which is core's `ChatMessageResult`, already
 * flat — render through one shape. `sender.username` below is kept only as
 * harmless defense-in-depth in case that ever changes; the controller as
 * written never sends it.
 */
export interface ChatMessageView {
  id: string;
  senderId: string;
  content: string;
  createdAt: string;
  senderUsername?: string | null;
  sender?: { username: string | null } | null;
  /** The sender's equipped title, resolved server-side (null when they wear none). */
  senderTitle?: { label: string; rarity: string } | null;
}

/** GET /me/chat/history — most recent page (server default: 50, hard-capped at 100) of the caller's world, newest first. The world is derived server-side from the caller, never passed in. */
export function fetchChatHistory(): Promise<ChatMessageView[]> {
  return api.get<ChatMessageView[]>('/me/chat/history');
}
